export default "__VITE_ASSET__DlXI6vhs__"